import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ContextService } from '@maximizer/core/shared/data-access';
import { Octopus } from '@maximizer/core/shared/domain';
import { Observable, catchError, map, of, timeout } from 'rxjs';

interface EmailSignatureRecord {
  Key: string;
  Signature: string;
}

interface EmailSignatureReadRequest {
  EmailSignature: Octopus.ReadRequest<EmailSignatureRecord>;
}

interface EmailSignatureReadResponse extends Octopus.Response {
  EmailSignature?: Octopus.DataResponse<EmailSignatureRecord>;
}

const SIGNATURE_TIMEOUT_MS = 8_000;

@Injectable()
export class EmailSignatureService {
  private readonly http = inject(HttpClient);
  private readonly context = inject(ContextService);

  read(userKey: string): Observable<string> {
    const key = userKey.trim();
    if (key === '') {
      return of('');
    }
    const request: EmailSignatureReadRequest = {
      EmailSignature: {
        Scope: { Fields: { Key: 1, Signature: 1 } },
        Criteria: { SearchQuery: { Key: { $EQ: key } } },
      },
    };
    return this.http
      .post<EmailSignatureReadResponse>(
        `${this.context.api}${Octopus.Action.READ}`,
        request,
      )
      .pipe(
        map((response) =>
          response.Code === Octopus.ResponseStatusCode.Successful
            ? (response.EmailSignature?.Data[0]?.Signature ?? '').trim()
            : '',
        ),
        timeout({ first: SIGNATURE_TIMEOUT_MS, with: () => of('') }),
        catchError(() => of('')),
      );
  }
}
